<template>
  <div class="sv-page">
    <header class="sv-page-header">
      <div>
        <span class="sv-page-header__eyebrow">Acessos e permissões</span>
        <h1>Usuários</h1>
        <p>Gerencie quem pode acessar a plataforma e as operações disponíveis.</p>
      </div>
    </header>

    <div class="row">
      <div class="col-xxl-12">
        <UsersList />
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import UsersList from "../../components/Users/UsersList.vue";
import { mapActions } from 'vuex';

export default defineComponent({
  name: "UsersPage",
  components: {
    UsersList
  },
  methods: {
    ...mapActions([
      "setUsersList",
      "setRolesList"
    ]),
  },
  mounted() {
    this.setUsersList();
    this.setRolesList();
  },
});
</script>
